import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";

const CheckinLogsService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Checkin%20Logs/List%20Checkin%20Logs
  getAll: async function (organizationId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/checkin-logs/`;
      const params = {
        ...filters,
        timestamp_after: RequestService.formatDate(filters.timestamp_after),
        timestamp_before: RequestService.formatDate(filters.timestamp_before),
      };
      return await RequestService.get(path, params);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Checkin%20Logs/Retrieve%20Checkin%20Logs
  get: async function (organizationId, checkinLogId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/checkin-logs/${checkinLogId}/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default CheckinLogsService;
